import {Metadata} from '../Metadata';
import {ObjectWrapper} from 'md-library-test-first-version';
import * as _ from 'lodash';
import {ObjectWrapperFactory} from 'md-library-test-first-version';

export class Factory {

    private objectWrapperFactory: ObjectWrapperFactory = null;

    // ########################################

    constructor(objectWrapperFactory: ObjectWrapperFactory) {
        this.objectWrapperFactory = objectWrapperFactory;
    }

    // ########################################

    public create(data = {}): Metadata {
        if (!_.isObject(data)) {
            throw new Error('Data is not valid.');
        }

        return new Metadata(data, this.objectWrapperFactory);
    }

    // ########################################
}
